import { useAppState } from '../../AppContext';
import { keywordWidth, metadataColumnWidth, padding } from './constants';
import { clusterColor } from '../utils';
import React from 'react';
import PropTypes from 'prop-types';

import { truncateString } from './utils';

const ExpandedGroup = ({
  startY,
  cluster,
  toggleCollapsed,
  matrixWidth,
  keywords,
  selectedColumn,
  setSelectedColumn
}) => {
  let [
    {
      selectedDocument,
      mousedOverDocument,
      tdMatrix,
      visibleMetadataColumns,
      documents
    },
    dispatch
  ] = useAppState();

  if (!tdMatrix) {
    return;
  }

  return (
    <>
      <g transform={`translate(0, ${15 + keywordWidth})`}>
        {/* Coloured background to keywords from this cluster*/}
        {cluster.keywords.map((keyword) =>
          keywords.includes(keyword) ? (
            <rect
              key={`${cluster}-${keyword}`}
              x={keywordWidth * keywords.indexOf(keyword)}
              width={keywordWidth}
              y={startY}
              height={cluster.members.length * keywordWidth}
              fill={clusterColor(cluster)}
              onClick={toggleCollapsed}
              style={{ opacity: 0.2 }}
            />
          ) : null
        )}

        {/* horizontal stripes */}
        {[...Array(cluster.members.length + 1).keys()].map((doc, i) => (
          <line
            key={`stripe-${i}`}
            x1={0}
            x2={matrixWidth}
            y1={startY + i * keywordWidth}
            y2={startY + i * keywordWidth}
            stroke={'grey'}
            onClick={toggleCollapsed}
            style={{ opacity: 0.2 }}
          >
            <title>{cluster.members.length}</title>
          </line>
        ))}

        {/* Keyword-document cell */}
        {cluster.members.map((doc, doc_index) => {
          return keywords.map((keyword, keyword_index) => {
            const x = keyword_index * keywordWidth;
            const highlighted =
              selectedColumn === keyword ||
              mousedOverDocument === doc.document_id ||
              selectedDocument.id === doc.document_id;
            const opacity = 0.3;

            if (!tdMatrix[keyword]) {
              console.log({ keyword });
              console.log({ tdMatrix });
              return null;
            }

            return tdMatrix[keyword].includes(doc.document_id) ? (
              <rect
                key={`keyword-title-${doc_index}-${keyword_index}`}
                x={x}
                y={startY + doc_index * keywordWidth}
                width={keywordWidth}
                height={keywordWidth}
                stroke={highlighted ? 'gold' : 'white'}
                strokeWidth={highlighted ? '3' : '1'}
                onMouseOver={() => {
                  setSelectedColumn(keyword);
                  dispatch({
                    type: 'SET_MOUSED_OVER_DOCUMENT',
                    mousedOverDocument: doc.document_id
                  });
                }}
                onMouseOut={() => {
                  setSelectedColumn(null);
                  dispatch({
                    type: 'SET_MOUSED_OVER_DOCUMENT',
                    mousedOverDocument: null
                  });
                }}
                opacity={opacity}
              />
            ) : null;
          });
        })}

        {/* Document metadata columns */}
        {cluster.members.map((doc, doc_index) => {
          let fullDoc = documents.filter((d) => d.id === doc.document_id)[0];

          return visibleMetadataColumns.map(
            (metadataColumn, metadataColumnIndex) => {
              const x =
                keywords.length * keywordWidth +
                padding +
                metadataColumnIndex * metadataColumnWidth;

              return (
                <text
                  key={`${doc_index}_${metadataColumnIndex}`}
                  x={x}
                  y={startY + doc_index * keywordWidth + keywordWidth - 5}
                >
                  {truncateString(fullDoc[metadataColumn], 22)}
                  <title>{fullDoc[metadataColumn]}</title>
                </text>
              );
            }
          );
        })}

        {/* Coloured lines to keywords from this cluster*/}
        {cluster.keywords.map((keyword) =>
          keywords.includes(keyword) ? (
            <React.Fragment key={`${cluster}-${keyword}`}>
              <line
                x1={keywordWidth * keywords.indexOf(keyword)}
                x2={keywordWidth * keywords.indexOf(keyword) + keywordWidth}
                y1={startY}
                y2={startY}
                strokeWidth={'5px'}
                stroke={clusterColor(cluster)}
                onClick={toggleCollapsed}
                style={{ opacity: 1 }}
              />
              <line
                x1={keywordWidth * keywords.indexOf(keyword)}
                x2={keywordWidth * keywords.indexOf(keyword) + keywordWidth}
                y1={startY + cluster.members.length * keywordWidth}
                y2={startY + cluster.members.length * keywordWidth}
                strokeWidth={'5px'}
                stroke={clusterColor(cluster)}
                onClick={toggleCollapsed}
                style={{ opacity: 1 }}
              />
            </React.Fragment>
          ) : null
        )}
      </g>
    </>
  );
};
ExpandedGroup.propTypes = {
  cluster: PropTypes.shape({
    members: PropTypes.array.isRequired,
    expanded: PropTypes.bool.isRequired,
    keywords: PropTypes.arrayOf(PropTypes.string)
  }),
  toggleCollapsed: PropTypes.func,
  matrixWidth: PropTypes.number,
  startY: PropTypes.number,
  keywords: PropTypes.arrayOf(PropTypes.string),

  selectedColumn: PropTypes.string,
  setSelectedColumn: PropTypes.func.isRequired
};

export default ExpandedGroup;
